<template>
  <div>
    <Loading v-if="loading" />
    <!-- Edit Rep -->
    <div v-if="rep" class="edit-rep">
      <h2>
        {{ rep.properties.firstname }} {{ rep.properties.lastname }} ({{
          rep.id
        }})
      </h2>
      <!-- Buttons -->
      <div class="edit-rep-buttons">
        <!-- Left -->
        <div>
          <button
            @click="showEditRep = !showEditRep"
            style="margin-right: 20px"
            class="primary"
          >
            Edit Rep. details
          </button>
          <button
            @click="deleteRep"
            class="secondary"
            v-if="rep.id !== apidata.me.id"
          >
            Delete Rep.
          </button>
        </div>
        <!-- Middle -->
        <div
          v-if="pendingRequestsTimeSlots > 0"
          style="display: flex; align-items: center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="
                    margin: auto;
                    background: rgba(255, 255, 255, 0);
                    display: block;
                  "
            width="40px"
            height="40px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
          >
            <circle
              cx="50"
              cy="50"
              r="25"
              stroke="rgba(255, 255, 255, 0)"
              stroke-width="10"
              fill="none"
            ></circle>
            <circle
              cx="50"
              cy="50"
              r="25"
              stroke="#0054a4"
              stroke-width="6"
              stroke-linecap="round"
              fill="none"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                repeatCount="indefinite"
                dur="1.5384615384615383s"
                values="0 50 50;180 50 50;720 50 50"
                keyTimes="0;0.5;1"
              ></animateTransform>
              <animate
                attributeName="stroke-dasharray"
                repeatCount="indefinite"
                dur="1.5384615384615383s"
                values="15.707963267948967 141.3716694115407;78.53981633974483 78.53981633974483;15.707963267948967 141.3716694115407"
                keyTimes="0;0.5;1"
              ></animate>
            </circle>
          </svg>
          Updating time slots
        </div>
        <!-- Right -->
        <div>
          <FormulateInput
            type="select"
            :options="timezones"
            v-model="timezone"
            @change="selectTimezone"
          />
        </div>
      </div>
      <!-- Calendar Buttons -->
      <div class="calendar-buttons">
        <button @click="changeWeek('previous')" class="tertiary">
          Previous Week
        </button>
        <!-- Legend -->
        <div class="legend">
          <div>
            <div class="legend-box available"></div>
            Available
          </div>
          <div>
            <div class="legend-box unavailable"></div>
            Unavailable
          </div>
          <div>
            <div class="legend-box booked"></div>
            Booked
          </div>
        </div>
        <button @click="changeWeek('next')" class="tertiary">
          Next Week
        </button>
      </div>
      <!-- Custom Calendar -->
      <div class="custom-calendar" style="margin-top: 30px">
        <div
          class="day"
          v-for="day in repCalendar"
          :key="day.date"
          :class="{ ui: day.type === 'ui' }"
        >
          <div class="day-title">
            <h4 style="margin: 0">{{ day.dateReadable }}</h4>
            <input
              type="checkbox"
              :checked="day.dominantSlot === 'available' ? true : false"
              v-if="day.type !== 'ui'"
              @change="bulkByDay(day)"
            />
          </div>
          <div
            v-for="slot in day.slots"
            :key="slot.from + day.date"
            :class="{
              clickable: slot.clickable,
              available: slot.event && slot.event.type === 'available',
              booked: slot.event && slot.event.type === 'booking',
            }"
          >
            <div v-if="day.type === 'ui'" class="slot ui">
              <div class="time">
                {{ slot.fromReadable }}
              </div>
              <input
                type="checkbox"
                :checked="slot.dominantSlot === 'available' ? true : false"
                @change="bulkByTime(slot)"
              />
            </div>
            <div
              v-else
              :class="{
                slot: true,
                clickable: slot.clickable,
                available: slot.event && slot.event.type === 'available',
                booked: slot.event && slot.event.type === 'booking',
              }"
              @click="selectSlot(slot, day)"
            >
              {{ slot.event ? slot.event.title : "" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddEditRep
      :is_admin_rep="currentView === 'admin_reps' ? true : false"
      v-if="showAddRep"
      @close="showAddRep = !showAddRep"
      @created="createdRep"
    />
    <AddEditRep
      v-if="showEditRep"
      @close="showEditRep = !showEditRep"
      :element_id="rep.id"
    />
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  data: function() {
    return {
      loading: null,
      showAddRep: false,
      showEditRep: false,
      rep: null,
      repEvents: null,
      repAvailability: null,
      repBookings: null,
      repCalendar: null,
      timezone: null,
      timezones: [
        {
          label: "Pacific Time",
          value: "America/Los_Angeles",
        },
        {
          label: "Mountain Time",
          value: "America/Denver",
        },
        {
          label: "Central Time",
          value: "America/Chicago",
        },
        {
          label: "Eastern Time",
          value: "America/New_York",
        },
      ],
      startOfWeek: null,
      pendingRequestsTimeSlots: 0,
    };
  },

  methods: {
    getRep: async function() {
      try {
        this.loading = true;
        const response = await this.$axios({
          method: "get",
          url: "https://enfhx8chnmicroq.m.pipedream.net",
          params: {
            contact_id: this.$route.params.id,
          },
        });

        this.rep = response.data.contact;
        await this.getRepCalendar();
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    deleteRep: async function() {
      try {
        if (!confirm("Do you wish to delete this Rep.?")) return;
        this.loading = true;
        await this.$axios({
          method: "get",
          url: "https://ens8y5vetwchhbt.m.pipedream.net",
          params: {
            contact_id: this.rep.id,
          },
        });

        this.$toast.success("Deleted");
        this.currentView = "this_system_reps";
        this.getReps();
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getRepCalendar: async function() {
      try {
        this.loading = true;
        const response = await this.$axios({
          method: "get",
          url: "https://enmkutocvn62o19.m.pipedream.net",
          params: {
            contact_id: this.rep.id,
            system_id: this.apidata.system.system_id,
          },
        });

        let events = [];

        const availability = response.data.rep.availability;
        if (availability) {
          for (const slot of availability) {
            events.push({
              from: slot.from,
              to: slot.to,
              type: "Available",
            });
          }
        }

        const unavailability = response.data.rep.unavailability;
        if (unavailability) {
          for (const slot of unavailability) {
            events.push({
              from: slot.from,
              to: slot.to,
              title: `Booked: ${slot.ticket_id}`,
              type: "Booking",
            });
          }
        }

        this.repEvents = events;

        this.repAvailability = response.data.rep.availability;
        this.repBookings = response.data.rep.unavailability;

        if (!this.timezone) {
          this.timezone = this.rep.properties.tac_timezone;
          if (
            !this.timezones.find((element) => element.value === this.timezone)
          ) {
            this.timezones.push({
              label: this.timezone,
              value: this.timezone,
            });
          }
          this.startOfWeek = moment.tz(this.timezone).startOf("week");
        }
        this.renderCalendar();
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    renderCalendar: function() {
      try {
        const initialTimezone = this.rep.properties.tac_timezone;
        if (!initialTimezone) throw new Error("This Rep has no timezone");
        const viewingTimezone = this.timezone;

        if (!this.startOfWeek) {
          this.startOfWeek = moment.tz(viewingTimezone).startOf("week");
        }
        let days = [];

        // Get left column of slots
        const randomDate = moment("2021-01-01 00:00");
        let slotsForDay = [];
        for (let i = 0; i < 24; i++) {
          const slotStart = randomDate.clone().add(i, "hours");
          const slotEnd = slotStart.clone().add(1, "hour");
          slotsForDay.push({
            from: slotStart.format("HH:mm"),
            to: slotEnd.format("HH:mm"),
            fromReadable: slotStart.format("h A"),
            toReadable: slotEnd.format("ha"),
            clickable: false,
          });
        }
        days.push({
          type: "ui",
          slots: slotsForDay,
        });

        // Calculate actual slots
        for (let i = 0; i < 7; i++) {
          const thisDate = this.startOfWeek.clone().add(i, "days");
          let slots = [];

          for (let j = 0; j < 24; j++) {
            const slotStart = thisDate.clone().add(j, "hours");
            const slotEnd = slotStart.clone().add(1, "hour");
            const startTimestamp = slotStart.valueOf();
            const endTimestamp = slotEnd.valueOf();

            let event;
            let bookings = [];
            if (this.repAvailability) {
              for (const doc of this.repAvailability) {
                if (doc.from === startTimestamp && doc.to === endTimestamp) {
                  event = {
                    type: "available",
                    from: doc.from,
                    to: doc.to,
                    id: doc.id,
                  };
                }
              }
            }
            if (this.repBookings) {
              for (const doc of this.repBookings) {
                if (doc.from === startTimestamp && doc.to === endTimestamp) {
                  event = {
                    type: "booking",
                    from: doc.from,
                    to: doc.to,
                    id: doc.id,
                    title: doc.ticket_id,
                    ticket_id: doc.ticket_id,
                  };
                  bookings.push(doc.id);
                }
              }
            }
            if (bookings.length > 1) {
              this.$toast.error(
                "Double booking detected. Please report data in console."
              );
              console.log(`Booking IDs: ${JSON.stringify(bookings)}`);
            }

            let clickable = false;
            const hourInInitialTimezone = slotStart
              .clone()
              .tz(initialTimezone)
              .hours();
            const dayInInitialTimezone = slotStart
              .clone()
              .tz(initialTimezone)
              .isoWeekday();

            if (
              hourInInitialTimezone >= 5 &&
              hourInInitialTimezone <= 19 &&
              dayInInitialTimezone <= 5
            ) {
              clickable = true;
            }

            slots.push({
              from: slotStart.format("HH:mm"),
              to: slotEnd.format("HH:mm"),
              fromReadable: slotStart.format("ha"),
              toReadable: slotEnd.format("ha"),
              event,
              clickable,
            });
          }

          days.push({
            date: thisDate.format("YYYY-MM-DD"),
            dateReadable: thisDate.format("ddd D MMM"),
            slots,
          });
        }

        // Calculate checkbox state for each day
        days = days.map((day) => {
          if (day.type === "ui") return day;

          let available = 0;
          let unavailable = 0;

          for (const slot of day.slots) {
            if (!slot.clickable) continue;
            if (slot.event?.type === "available") {
              available++;
            } else if (slot.event?.type === "booking") {
              unavailable++;
            } else {
              unavailable++;
            }
          }

          const dominantSlot =
            available > unavailable ? "available" : "unavailable";

          return {
            dominantSlot,
            ...day,
          };
        });

        // Calculate checkbox state for each time slot
        const newFirstDay = days[0].slots.map((slotUI) => {
          let available = 0;
          let unavailable = 0;

          for (const day of days) {
            if (day.type === "ui") continue;
            for (const slot of day.slots) {
              if (!slot.clickable) continue;
              if (slot.from !== slotUI.from) continue;
              if (slot.event?.type === "available") {
                available++;
              } else if (slot.event?.type === "booking") {
                unavailable++;
              } else {
                unavailable++;
              }
            }
          }

          const dominantSlot =
            available > unavailable ? "available" : "unavailable";

          return {
            dominantSlot,
            ...slotUI,
          };
        });
        days[0] = {
          ...days[0],
          slots: newFirstDay,
        };

        this.repCalendar = days;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      }
    },
    selectSlot: async function(slot, day) {
      try {
        this.pendingRequestsTimeSlots++;

        if (slot.event?.type === "available") {
          // Delete slot from database
          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "delete",
            },
            data: {
              slots: [slot.event.id],
            },
          });

          await this.getRepCalendar();
          this.renderCalendar();
        } else if (slot.event?.type === "booking") {
          // Open ticket
          this.selectTicket(slot.event.ticket_id);
        } else {
          if (!slot.clickable) return;
          // Add slot to database
          const systems = this.rep.properties.tac_system.split(";");
          if (!systems[0]) throw new Error("Couldn't get system for this rep");

          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "create",
            },
            data: {
              slots: [
                {
                  from: moment
                    .tz(`${day.date} ${slot.from}`, this.timezone)
                    .valueOf(),
                  to: moment
                    .tz(`${day.date} ${slot.to}`, this.timezone)
                    .valueOf(),
                  rep_contact_id: this.rep.id,
                  systems,
                },
              ],
            },
          });

          await this.getRepCalendar();
          this.renderCalendar();
        }
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.pendingRequestsTimeSlots--;
      }
    },
    selectTicket: async function(ticket_id) {
      const routeData = this.$router.resolve(`/tickets/${ticket_id}`);
      window.open(routeData.href, "_blank");
    },
    changeWeek: function(action) {
      if (action === "next") {
        this.startOfWeek = this.startOfWeek.add(1, "week");
      } else {
        this.startOfWeek = this.startOfWeek.subtract(1, "week");
      }
      this.renderCalendar();
    },
    bulkByDay: async function(day) {
      try {
        this.pendingRequestsTimeSlots++;

        if (day.dominantSlot === "available") {
          // Delete all available slots
          const slotsToDelete = day.slots.reduce((accumulator, slot) => {
            if (slot.event?.type === "available" && slot.clickable) {
              accumulator.push(slot.event?.id);
            }
            return accumulator;
          }, []);
          if (!slotsToDelete.length) return;
          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "delete",
            },
            data: {
              slots: slotsToDelete,
            },
          });
        }

        if (day.dominantSlot === "unavailable") {
          // Make all unavailable slots available
          const systems = this.rep.properties.tac_system.split(";");
          if (!systems[0]) throw new Error("Couldn't get system for this rep");

          const slotsToAdd = day.slots.reduce((accumulator, slot) => {
            if (!slot.event && slot.clickable) {
              accumulator.push({
                from: moment
                  .tz(`${day.date} ${slot.from}`, this.timezone)
                  .valueOf(),
                to: moment
                  .tz(`${day.date} ${slot.to}`, this.timezone)
                  .valueOf(),
                rep_contact_id: this.rep.id,
                systems,
              });
            }
            return accumulator;
          }, []);
          if (!slotsToAdd.length) return;
          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "create",
            },
            data: {
              slots: slotsToAdd,
            },
          });
        }

        await this.getRepCalendar();
        this.renderCalendar();
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.pendingRequestsTimeSlots--;
      }
    },
    bulkByTime: async function(slotUI) {
      try {
        this.pendingRequestsTimeSlots++;

        if (slotUI.dominantSlot === "available") {
          // Delete all available slots
          let slotsToDelete = [];
          for (const day of this.repCalendar) {
            if (day.type === "ui") continue;
            for (const slot of day.slots) {
              if (
                slot.event?.type === "available" &&
                slot.clickable &&
                slot.from === slotUI.from
              ) {
                slotsToDelete.push(slot.event?.id);
              }
            }
          }
          if (!slotsToDelete.length) return;
          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "delete",
            },
            data: {
              slots: slotsToDelete,
            },
          });
        }

        if (slotUI.dominantSlot === "unavailable") {
          // Make all unavailable slots available
          const systems = this.rep.properties.tac_system.split(";");
          if (!systems[0]) throw new Error("Couldn't get system for this rep");

          let slotsToAdd = [];
          for (const day of this.repCalendar) {
            if (day.type === "ui") continue;
            for (const slot of day.slots) {
              if (!slot.event && slot.clickable && slot.from === slotUI.from) {
                slotsToAdd.push({
                  from: moment
                    .tz(`${day.date} ${slot.from}`, this.timezone)
                    .valueOf(),
                  to: moment
                    .tz(`${day.date} ${slot.to}`, this.timezone)
                    .valueOf(),
                  rep_contact_id: this.rep.id,
                  systems,
                });
              }
            }
          }
          if (!slotsToAdd.length) return;
          await this.$axios({
            method: "post",
            url: "https://en4s26to20h3c4o.m.pipedream.net",
            params: {
              action: "create",
            },
            data: {
              slots: slotsToAdd,
            },
          });
        }

        await this.getRepCalendar();
        this.renderCalendar();
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.pendingRequestsTimeSlots--;
      }
    },
    selectTimezone: function() {
      this.startOfWeek = moment.tz(this.timezone).startOf("week");
      this.renderCalendar();
    },
  },

  created: async function() {
    await this.getRep();
  },
};
</script>

<style scoped>
.edit-rep-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-calendar {
  display: flex;
}

.custom-calendar .day {
  margin-right: 20px;
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.custom-calendar .day.ui {
  margin-right: 0;
  width: 80px;
}

.custom-calendar .day-title {
  height: 30px;
  margin-bottom: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-calendar .day-title input {
  transform: scale(1.4);
}

.custom-calendar .slot {
  height: 25px;
  margin-bottom: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
}

.custom-calendar .slot:not(.ui) {
  background-color: rgb(248, 248, 248);
  /* opacity: 0.1; */
}

.custom-calendar .slot.available {
  background-color: lightgreen !important;
  opacity: 1;
  cursor: pointer;
}

.custom-calendar .slot.booked {
  background-color: rgb(0, 110, 184) !important;
  opacity: 1;
  color: white;
  font-size: 10px;
  cursor: pointer;
}

.custom-calendar .slot.clickable {
  background-color: lightcoral;
  opacity: 1;
  cursor: pointer;
}

.calendar-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;
}

.edit-rep {
  max-width: 925px;
}

.custom-calendar .slot.ui .time {
  width: 50px;
}

.legend {
  display: flex;
}

.legend > div {
  display: flex;
  align-items: center;
}

.legend-box {
  width: 20px;
  height: 20px;
  margin: 0 5px;
}

.legend-box.available {
  background-color: lightgreen;
}

.legend-box.unavailable {
  background-color: lightcoral;
}

.legend-box.booked {
  background-color: rgb(0, 110, 184);
}
</style>
